<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Update Handle for&nbsp;<span v-if="report && report.instagram"> @{{report.instagram}}</span>
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <v-select
            dense
            placeholder="Platform"
            v-model="updateData.platform"
            :items="platforms"
            @input="$v.updateData.platform.$touch()"
            :error-messages="$v.updateData.platform.$error && `Platform is required.`"
            @blur="$v.updateData.platform.$touch()"
            @change="changePlatform()"
            outlined
            attach
          ></v-select>
        </div>
        <div>
          <v-select
            dense
            placeholder="Handle"
            v-model="updateData.handle"
            :items="viewPlatforms"
            @input="$v.updateData.handle.$touch()"
            :error-messages="$v.updateData.handle.$error && `Handle is required.`"
            @blur="$v.updateData.handle.$touch()"
            outlined
            attach
          ></v-select>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.updateData.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import influencerAPIs from '../../views/Influencer/influencerAPIs';
// import config from '@/config';
// import moment from 'moment'
// import utils from '@/utils';
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'EditReportHandleModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    report: Object
  },
  validations: {
    updateData: {
      handle: { required },
      platform: { required }
    }
  },
  data () {
    return {
      isLoading: false,
      platforms: ['Instagram', 'TikTok', 'Youtube', 'Xiaohongshu', 'Facebook'],
      platformList: [
        {
          text: 'Instagram',
          value: 'instagram'
        },
        {
          text: 'TikTok',
          value: 'tiktok'
        },
        {
          text: 'Youtube',
          value: 'youtube'
        },
        {
          text: 'Xiaohongshu',
          value: 'xiaohongshu'
        },
        {
          text: 'Facebook',
          value: 'facebook'
        }
      ],
      viewPlatforms: [],
      updateData: {
        handle: '',
        platform: ''
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      updatedReport: state => state.campaign.updatedReport
    })
  },
  watch: {
    value: function(newValue) {
      this.updateData = {
        handle: '',
        platform: ''
      }
      this.viewPlatforms = []
      this.getPlatformDataToView()
    }
  },
  methods: {
    async save() {
      this.isLoading = true
      let saveData = Object.assign({}, {
        id: this.report.id,
        ...this.updateData
      })
      await this.$store.dispatch('campaign/updateReportHandle', {
        updateData: saveData
      })
      this.isLoading = false
      if (this.updatedReport) {
        this.$swal({
          text: 'Successfully Updated.',
          type: 'success'
        })
        this.$emit('saved')
        this.close()
      } else {
        this.$swal({
          text: 'Error Updating Handle!',
          type: 'error'
        })
      }
    },
    async getPlatformDataToView() {
      this.isLoading = true
      let infID = null
      let resp = await influencerAPIs.getInfluencerByHandles({
        searchHandles: [
          this.report.instagram
        ]
      })
      if (resp.length) {
        resp = resp[0]
        infID = resp.id
      }
      influencerAPIs
        .getInfluencer(infID)
        .then(response => {
          this.selectedInfluencerID = infID
          this.platformList = this.platformList.map(p => {
            if (p.value === 'instagram' && response.instagram) {
              p.handle = response.instagram.instagramHandle
            }
            if (p.value === 'tiktok' && response.tiktok) {
              p.handle = response.tiktok.tiktokHandle || ''
            }
            if (p.value === 'youtube' && response.youtube) {
              p.handle = response.youtube.youtubeHandle || ''
            }
            if (p.value === 'facebook' && response.facebook) {
              p.handle = response.facebook.handle || ''
            }
            if (p.value === 'xiaohongshu' && response.xiaohongshu) {
              p.handle = response.xiaohongshu.xhsHandle || ''
            }
            return p
          })
          this.platforms = this.platforms.filter(p => {
            let matchPlatform = this.platformList.find(pl => {
              if (pl.text === p && pl.handle) {
                return true
              }
              return false
            })
            if (matchPlatform) return true
            return false
          })
          this.isLoading = false
        })
        .catch(error => {
          // Request failed.
          this.isLoading = false
          console.log('error', error);
        });
    },
    changePlatform() {
      this.viewPlatforms = []
      let matchPlatform = this.platformList.find(p => p.value === this.updateData.platform.toLowerCase())
      if (matchPlatform) {
        this.viewPlatforms.push(matchPlatform.handle)
        this.updateData.handle = matchPlatform.handle
      }
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// EditReportHandleModal.vue?4f0a147e